export const authApi = {
  logIn: {
    queryKey: (params?: string[]) => ["auth", ...(params || [])],
    route: () => `auth/admin`,
    methods: ["POST"],
  },
  changePassword: {
    queryKey: (params?: string[]) => ["auth", ...(params || [])],
    route: () => `auth/change-password`,
    methods: ["PATCH"],
  },
};
